module.exports = __webpack_public_path__ + "static/media/13.ab9cfefa.svg";